export const getAppSearchRoles = `query GetAppSearchRoles($application: String!) {
    getAppSearchRoles(application: $application) {
              role  
            }
         } 
`;